import React from "react";
import { cn } from "../../lib/cn";

export function Result({ status, title, subTitle, extra, className }) {
  return (
    <div
      className={cn(
        "mx-auto flex max-w-lg flex-col items-center justify-center gap-3 rounded-2xl border border-slate-200 bg-white px-8 py-16 text-center shadow-sm",
        className
      )}
    >
      <div
        className={cn(
          "flex h-16 w-16 items-center justify-center rounded-full text-2xl font-bold text-white shadow-inner",
          status === "403" ? "bg-amber-500" : "bg-brand"
        )}
      >
        !
      </div>
      <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
      {subTitle ? (
        <p className="text-sm leading-relaxed text-slate-600">{subTitle}</p>
      ) : null}
      {extra}
    </div>
  );
}
